//@flow
import React, { useState } from 'react';
import Link from '../../../components/Link';
import UrlData from '../../Utils/url-data';
import EmailForm from '../../Homepage/components/EmailForm.react';
import Constants from '../../constants';

export default function Footer() {
  return (
    <footer>
      <SailthruForm />
      <div>
        <ul className="nb-links">
          <li><Link to="/aboutus" external={true}>About Us</Link></li>
          <li><a href="https://naturebox.com/blog">Blog</a></li>
          <li><a href={Constants.SUPPORT_LINK}>FAQs</a></li>
          <li><a href="https://naturebox.com/jobs">Jobs</a></li>
          <li><a href={UrlData.getOfficeUrl()}>Office Snacks</a></li>
          <li><Link to="/membership" external={true}>Membership</Link></li>
          <li><Link to="/privacy" external={true}>Privacy</Link> & <Link to="/terms" external={true}>Terms</Link></li>
          <li><Link to="/accessibility" external={true}>Accessibility</Link></li>
        </ul>
        <div className="copyright">&copy; {new Date().getFullYear()} NatureBox. All Rights Reserved.</div>
      </div>
    </footer>
  );
}

function SailthruForm() {
  const [subscribed, setSubscribed] = useState(false);

  const onSubmit = () => {
    setSubscribed(true);
  };

  if (subscribed) {
    return (
      <div className="sailthru-form">
        <h2>Sign up & get exclusive offers!</h2>
        <div className="success-message">Thanks! You&apos;re signed up</div>
      </div>
    );
  }

  return(
    <div className="sailthru-form">
      <h2>Sign up & get exclusive offers!</h2>
      <EmailForm
        text="Subscribe"
        onSubmit={onSubmit}
        list="mem_prospect"
        placeholder="Email"
      />
    </div>
  );
}
